<template >
  <div class="card dash-card comment-item">
     {{questionText}}
  </div>
</template>

<script>
  export default {
    props:{
      questionText: String
    }
  }
</script>
